<template>
  <main class="page groups-page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Группы</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mr-20">
        <div class="page__row">
          <div class="page__item groups-page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setGroupsSearchValue"
            />
          </div>
          <div class="page__item"></div>
        </div>
        <div class="page__item">
          <div class="page__row">
            <div class="page__item" v-if="roleAccessCreate">
              <AppButtonSmAdd title="Создать" @click.native="showCreateModal" />
            </div>
          </div>
        </div>
      </div>
      <div class="page__row mb-40">
        <AppSelect title="Сортировать:"
                   :value="sort.value"
                   :options="sort.options"
                   placeholder="Выберите сортировку"
                   @value-changed="setGroupsSort"
        />
      </div>
      <div class="group-list mb-20" v-if="groups.length !== 0">
        <router-link :to="`/user/groups/${group.id}`" class="group" v-for="group in groups" :key="group.id">
          <div class="group__remove" @click.prevent.stop="showRemoveConfirmation(group.id)" v-if="roleAccessRemove">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.09091 11.375C5.09091 11.5391 4.9517 11.6667 4.77273 11.6667H4.13636C3.95739 11.6667 3.81818 11.5391 3.81818 11.375V4.95834C3.81818 4.79428 3.95739 4.66667 4.13636 4.66667H4.77273C4.9517 4.66667 5.09091 4.79428 5.09091 4.95834V11.375ZM7.63636 11.375C7.63636 11.5391 7.49716 11.6667 7.31818 11.6667H6.68182C6.50284 11.6667 6.36364 11.5391 6.36364 11.375V4.95834C6.36364 4.79428 6.50284 4.66667 6.68182 4.66667H7.31818C7.49716 4.66667 7.63636 4.79428 7.63636 4.95834V11.375ZM10.1818 11.375C10.1818 11.5391 10.0426 11.6667 9.86364 11.6667H9.22727C9.0483 11.6667 8.90909 11.5391 8.90909 11.375V4.95834C8.90909 4.79428 9.0483 4.66667 9.22727 4.66667H9.86364C10.0426 4.66667 10.1818 4.79428 10.1818 4.95834V11.375ZM4.77273 2.33333L5.25994 1.26694C5.28977 1.23048 5.36932 1.17579 5.42898 1.16668H8.58097C8.63068 1.17578 8.72017 1.23048 8.75 1.26694L9.22727 2.33333H4.77273ZM14 2.625C14 2.46094 13.8608 2.33333 13.6818 2.33333H10.6094L9.91335 0.811207C9.71449 0.364593 9.1179 0 8.59091 0H5.40909C4.8821 0 4.28551 0.364593 4.08665 0.811207L3.39062 2.33333H0.318182C0.139205 2.33333 0 2.46094 0 2.625V3.20834C0 3.37241 0.139205 3.50001 0.318182 3.50001H1.27273V12.1771C1.27273 13.1797 1.98864 14 2.86364 14H11.1364C12.0114 14 12.7273 13.1432 12.7273 12.1406V3.50001H13.6818C13.8608 3.50001 14 3.37241 14 3.20834V2.625Z" fill="currentColor"/>
            </svg>
          </div>
          <div class="group__header">
            <div class="group__avatar user-avatar" :style="`background: ${group.color}; box-shadow: 0 0 0 2px ${group.color};`">
              <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.578 3.83416C17.578 5.27849 16.3678 6.44934 14.8749 6.44934C13.382 6.44934 12.1717 5.27849 12.1717 3.83416C12.1717 2.38984 13.382 1.21898 14.8749 1.21898C16.3678 1.21898 17.578 2.38984 17.578 3.83416ZM18.838 3.83416C18.838 5.3158 17.9694 6.60116 16.6978 7.23953C17.8624 7.59073 18.896 8.27178 19.6617 9.19962C20.3529 10.0372 20.793 11.0363 20.9427 12.0882H21V13.3072H12.1045C12.1404 13.4639 12.1697 13.622 12.1924 13.781H12.2497V14.5871V14.5901V15H0V14.5901V13.781H0.0573702C0.128603 13.2811 0.265722 12.7909 0.466228 12.3225C0.774031 11.6036 1.22519 10.9504 1.79393 10.4002C2.36268 9.84993 3.03788 9.41346 3.78098 9.11567C3.95197 9.04715 4.12578 8.98629 4.30187 8.93317C3.03027 8.29483 2.16151 7.00943 2.16151 5.52772C2.16151 3.41017 3.93587 1.69356 6.12466 1.69356C8.31345 1.69356 10.0878 3.41017 10.0878 5.52772C10.0878 7.00937 9.21913 8.29472 7.94761 8.9331C8.12379 8.98623 8.29768 9.04712 8.46876 9.11567C8.89639 9.28704 9.30154 9.50433 9.67685 9.76281C10.2865 8.81627 11.1628 8.05132 12.2088 7.56198C12.4826 7.43388 12.7645 7.32633 13.0521 7.23961C11.7805 6.60126 10.9117 5.31586 10.9117 3.83416C10.9117 1.71661 12.6861 0 14.8749 0C17.0637 0 18.838 1.71661 18.838 3.83416ZM11.677 12.0882H19.7133C19.5733 11.304 19.2309 10.5618 18.7121 9.93304C18.0176 9.09141 17.0481 8.50309 15.9625 8.26457C14.877 8.02604 13.7399 8.15147 12.7378 8.62028C11.8389 9.04079 11.0964 9.71518 10.6059 10.5506C11.0442 11.0057 11.4056 11.5246 11.677 12.0882ZM8.82782 5.52772C8.82782 6.97205 7.61758 8.1429 6.12466 8.1429C4.63175 8.1429 3.4215 6.97205 3.4215 5.52772C3.4215 4.0834 4.63175 2.91254 6.12466 2.91254C7.61758 2.91254 8.82782 4.0834 8.82782 5.52772ZM11.0426 13.781H1.20719C1.26962 13.4259 1.37311 13.0777 1.51629 12.7433C1.76697 12.1578 2.13441 11.6258 2.59761 11.1777C3.06082 10.7296 3.61072 10.3741 4.21593 10.1316C4.82114 9.88903 5.4698 9.7642 6.12487 9.7642C6.77994 9.7642 7.4286 9.88903 8.03381 10.1316C8.63902 10.3741 9.18892 10.7296 9.65213 11.1777C10.1153 11.6258 10.4828 12.1578 10.7335 12.7433C10.8766 13.0777 10.9801 13.4259 11.0426 13.781Z" fill="currentColor"/>
              </svg>
            </div>
            <div class="group__name">{{ group.name }}</div>
          </div>
          <div class="group__info">
            <div class="group__members">
              <div class="group__members-icon">
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.1913 7.84615C8.74302 7.84615 10.0009 6.58823 10.0009 5.03651C10.0009 3.48479 8.74302 2.22688 7.1913 2.22688C5.63958 2.22688 4.38166 3.48479 4.38166 5.03651C4.38166 6.58823 5.63958 7.84615 7.1913 7.84615ZM7.1913 9.43533C9.6207 9.43533 11.5901 7.46591 11.5901 5.03651C11.5901 2.60711 9.6207 0.637695 7.1913 0.637695C4.7619 0.637695 2.79248 2.60711 2.79248 5.03651C2.79248 7.46591 4.7619 9.43533 7.1913 9.43533Z" fill="currentColor"/>
                  <path d="M13.9894 15.4329C13.9894 14.5402 13.8136 13.6562 13.4719 12.8314C13.1303 12.0066 12.6295 11.2572 11.9983 10.6259C11.367 9.99464 10.6176 9.49389 9.79279 9.15225C8.96799 8.81061 8.08399 8.63477 7.19124 8.63477C6.29849 8.63477 5.41448 8.81061 4.58969 9.15225C3.7649 9.49389 3.01547 9.99464 2.3842 10.6259C1.75294 11.2572 1.25219 12.0066 0.910546 12.8314C0.568906 13.6562 0.393066 14.5402 0.393066 15.4329H1.86514C1.86514 14.7335 2.0029 14.0409 2.27056 13.3947C2.53822 12.7485 2.93054 12.1614 3.42512 11.6668C3.91969 11.1722 4.50684 10.7799 5.15303 10.5123C5.79922 10.2446 6.49181 10.1068 7.19124 10.1068C7.89067 10.1068 8.58326 10.2446 9.22945 10.5123C9.87564 10.7799 10.4628 11.1722 10.9574 11.6668C11.4519 12.1614 11.8443 12.7485 12.1119 13.3947C12.3796 14.0409 12.5173 14.7335 12.5173 15.4329H13.9894Z" fill="currentColor"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5173 15.4329H13.9894C13.9894 14.5402 13.8136 13.6562 13.4719 12.8314C13.2301 12.2475 12.9085 11.7014 12.5173 11.2083C12.3559 11.0048 12.1827 10.8103 11.9983 10.6259C11.367 9.99464 10.6176 9.49389 9.79279 9.15225C8.96799 8.81061 8.08399 8.63477 7.19124 8.63477C6.29849 8.63477 5.41448 8.81061 4.58969 9.15225C3.7649 9.49389 3.01547 9.99464 2.3842 10.6259C2.19981 10.8103 2.02655 11.0048 1.86514 11.2083C1.47397 11.7014 1.15239 12.2475 0.910546 12.8314C0.568906 13.6562 0.393066 14.5402 0.393066 15.4329H1.86514C1.86514 14.7335 2.0029 14.0409 2.27056 13.3947C2.53822 12.7485 2.93054 12.1614 3.42512 11.6668C3.91969 11.1722 4.50683 10.7799 5.15303 10.5123C5.79922 10.2446 6.49181 10.1068 7.19124 10.1068C7.89067 10.1068 8.58326 10.2446 9.22945 10.5123C9.87564 10.7799 10.4628 11.1722 10.9574 11.6668C11.4519 12.1614 11.8443 12.7485 12.1119 13.3947C12.3796 14.0409 12.5173 14.7335 12.5173 15.4329Z" fill="currentColor"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9894 15.9993H0.393066V14.4102H13.9894V15.9993Z" fill="currentColor"/>
                </svg>
              </div>
              участников: {{ group.users_count }}
            </div>
          </div>
        </router-link>
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Нет ни одной группы"
                                   placeholder-width="320px"
          />
        </div>
      </div>
    </section>

    <section class="section page__footer">
    </section>

    <transition name="fade">
      <UserGroupsModal v-if="createModal.active"
                       :state="createModal"
                       @set-name="setGroupName"
                       @set-color="setGroupColor"
                       @add-member="addGroupMember"
                       @remove-member="removeGroupMember"
                       @save-info="createGroup"
                       @close-modal="closeCreateModal"
                       @cancel-creation="clearAndCloseCreateModal"
      />
      <AppConfirmation v-if="removeConfirmation.active"
                       text="Вы действительно хотите удалить эту группу?"
                       @confirm="removeGroup"
                       @reject="closeRemoveConfirmation"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import SearchForm from '../../components/page/input/SearchForm'
import AppConfirmation from '../../components/page/modal/AppConfirmation'
import AppButtonSmAdd from '../../components/page/button/AppButtonSmAdd'
import ThePagePreloader from '../../components/page/ThePagePreloader'
import AppNoRecordsPlaceholder from '../../components/page/text/AppNoRecordsPlaceholder'
import UserGroupsModal from '@/components/page/modal/UserGroupsModal'
import AppSelect from '@/components/page/input/AppSelect'

export default {
  name: 'UserGroups',
  components: {
    AppSelect,
    UserGroupsModal,
    AppNoRecordsPlaceholder,
    ThePagePreloader,
    AppButtonSmAdd,
    AppConfirmation,
    SearchForm
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        groupId: null
      }
    }
  },
  computed: {
    groups () {
      return this.$store.getters.userGroups
    },
    createModal () {
      return this.$store.getters.userGroupsCreateModal
    },
    searchValue () {
      return this.$store.getters.userGroupsSearchValue
    },
    sort () {
      return this.$store.getters.userGroupsSort
    },
    isLoading () {
      return this.$store.getters.userGroupsIsLoading
    },

    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightsUserGroups.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightsUserGroups.actions.remove
    }
  },
  methods: {
    showCreateModal () {
      this.$store.dispatch('userGroupsShowCreateModal')
    },
    setGroupName (name) {
      this.$store.dispatch('userGroupsCreateModalSetName', name)
    },
    setGroupColor (color) {
      this.$store.dispatch('userGroupsCreateModalSetColor', color)
    },
    addGroupMember (user) {
      this.$store.dispatch('userGroupsCreateModalAddMember', user)
    },
    removeGroupMember (user) {
      this.$store.dispatch('userGroupsCreateModalRemoveMember', user)
    },
    closeCreateModal () {
      this.$store.dispatch('userGroupsCloseCreateModal')
    },
    clearAndCloseCreateModal () {
      this.$store.dispatch('userGroupsClearAndCloseCreateModal')
    },
    createGroup () {
      this.$store.dispatch('userGroupsCreateGroup')
    },
    removeGroup () {
      const groupId = this.removeConfirmation.groupId
      this.$store.dispatch('userGroupsRemoveGroup', groupId)
      this.removeConfirmation.active = false
      this.removeConfirmation.groupId = null
    },
    showRemoveConfirmation (groupId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.groupId = groupId
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.groupId = null
    },

    // search
    setGroupsSearchValue (searchValue) {
      this.$store.dispatch('setUserGroupsSearchValue', searchValue)
    },

    // sort
    setGroupsSort (sort) {
      this.$store.dispatch('setUserGroupsSort', sort)
    }
  },
  mounted () {
    this.$store.dispatch('getUserGroups')
  }
}
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/system/vars";
@import "../../../src/assets/css/system/mixins";

.groups-page {
  // стандартный - 20px на правый отступ карточек
  padding-right: 155px;

  &__search {
    width: 682px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}

.group-list {
  display: flex;
  flex-flow: row wrap;
}

.group {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.22);
  width: 100%;
  max-width: 448px;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 20px;
  cursor: pointer;
  transition: .3s;

  &:hover {
    box-shadow: none;
    .group__remove {
      opacity: 1;
    }
  }

  &:active {
    box-shadow: inset 0 4px 4px rgba(23, 63, 125, 0.22);
  }

  &__remove {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    @include size(14px);
    top: 12px;
    left: auto;
    right: 12px;
    color: $color_deactive-second;
    opacity: 0;
    transition: .3s;

    &:hover {
      color: $font_color_third;
    }
  }

  &__header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 16px;
  }

  &__avatar {
    @include size(45px);
    color: $color_main;
    margin-right: 14px;
  }

  &__name {
    width: 80%;
    color: $font_color_third;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-y: hidden;
  }

  &__members {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    justify-content: flex-end;
    font-size: 14px;
    color: $color_deactive-second;
  }

  &__members-icon {
    margin-right: 6px;
  }
}
</style>
